import React from 'react';

const RadioGroup = ({ label, name, options, selectedValue, onChange }) => (
    <div className="form-group mb-4">
        <label className="form-label">{label}</label>
        {options.map((option, index) => (
            <div
                key={index}
                className={`padc bullet w-100 d-flex align-items-center gap-3 mb-4 ${selectedValue === option.value ? 'active-check' : ''}`}
                onClick={() => onChange(option.value)}
                style={{ cursor: 'pointer' }}
            >
                <div className="label-cs"></div>
                <span className="metropill">{option.label}</span>
            </div>
        ))}
    </div>
);

export default RadioGroup;
